export enum BuildingDetailsStyle {
  EmbeddedInMenu = 'embedded-in-menu',
  FloatingCard = 'floating-card',
}
